import { configureStore, combineReducers } from '@reduxjs/toolkit';
import apiConfigurationstate from './apiConfigurationstate';
import baggageEntryFlightStateSlice from './baggageEntryFlightState';
import pathSlice from './path/index';
import beltSlice from './belt/index';
import baggageArrivalFlightStateSlice from './baggageArrivalFlightState';
import baggageReallocationStateSlice from './BaggageReallocationState';
import animationSlice from './animation';

const store = configureStore({
	reducer: combineReducers({
		baggageEntryFlightState: baggageEntryFlightStateSlice,
		pathStore: pathSlice,
		beltStore: beltSlice,
		baggageArrivalFlightState: baggageArrivalFlightStateSlice,
		baggageReallocationStateStore: baggageReallocationStateSlice,
		animationStore: animationSlice,
		apiConfigurationstate: apiConfigurationstate
	})
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

export default store;
